export default __webpack_public_path__ + "static/rowPinning-6592cc0bdd443a8d72b955d184eaa3ea.gif";